<!-- 在线监控-流量 -->
<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('站点名称')">
              <a-input :placeholder="$t('请输入站点名称')" v-model="queryParam.stationName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无图片') }}</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">{{ $t('无文件') }}</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            {{ $t('下载') }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
        </span>
      </a-table>
    </div>
  </div>
</template>
  
  <script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { httpAction, getAction, postAction } from '@/api/manage'
import { AreaChoosetMixin } from '@/mixins/AreaChooseMixin'
import Vue from 'vue'

export default {
  name: 'internetTraffic',
  mixins: [JeecgListMixin, mixinDevice, AreaChoosetMixin],
  components: {},
  data() {
    return {
      description: '在线监控-流量',
      url: {
        list: '/jeecg-gis/topology/node/pageNodeAndIot',
      },
      dictOptions: {},
      superFieldList: [],
      areaTree: [],
      currSelected: [],
      areaLoading: false,
      collapsed: false,
    }
  },
  created() {},
  computed: {
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: (t, r, index) => {
            return parseInt(index) + 1
          },
        },
        {
          title: this.$t('分区名称'),
          align: 'center',
          dataIndex: 'stationName',
          customRender: (t, r, index) => {
            return r.area && r.area.name
          },
        },
        {
          title: this.$t('分区编码'),
          align: 'center',
          dataIndex: 'stationCode',
          customRender: (t, r, index) => {
            return r.area && r.area.code
          },
        },
        {
          title: this.$t('节点名称'),
          align: 'center',
          dataIndex: 'nodeName',
          customRender: (t, r, index) => {
            return r.node && r.node.name
          },
        },
        {
          title: this.$t('节点编码'),
          align: 'center',
          dataIndex: 'nodeCode',
          customRender: (t, r, index) => {
            return r.node && r.node.code
          },
        },
        {
          title: this.$t('物联设备编码'),
          align: 'center',
          dataIndex: 'deviceId',
          customRender: (t, r, index) => {
            return r.deviceData && r.deviceData.deviceId
          },
        },
        {
          title: this.$t('流量(m³/h)'),
          align: 'center',
          dataIndex: 'throughput',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.throughput
          },
        },
        {
          title: this.$t('反向流量(m³/h)'),
          align: 'center',
          dataIndex: 'throughputMinus',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.throughputMinus
          },
        },
        {
          title: this.$t('累计流量(m³)'),
          align: 'center',
          dataIndex: 'throughputTotal',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.throughputTotal
          },
        },
        {
          title: this.$t('瞬时流量(m³)'),
          align: 'center',
          dataIndex: 'flow',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.flow
          },
        },
        {
          title: this.$t('时间'),
          align: 'center',
          dataIndex: 'sysTime',
          customRender: (t, r, index) => {
            return r.iotData && r.iotData.sysTime
          },
        },
      ]
    },
  },
  methods: {
    loadData() {
      if (!this.queryParam.topologyCode) {
        // 默认使用 em_base 项目
        this.$set(this.queryParam, 'topologyCode', 'em_base')
        this.$set(this.queryParam, 'projectCode', 'em_base')
      }

      let params = {
        projectCode: this.queryParam.projectCode,
        topologyCode: this.queryParam.topologyCode,
        areaCode: this.queryParam.areaCode || '',
        name: this.queryParam.stationName || '',
        code: '',
        type: 'NODE_PIPELINE_TYPE_FM',
        page: {
          current: this.ipagination.current,
          size: this.ipagination.pageSize,
        },
      }

      this.loading = true
      postAction(this.url.list, params).then(res => {
        this.loading = false
        if (res.success) {
          this.dataSource = res.result.records
          this.ipagination.total = res.result.total
        } else {
          this.dataSource = []
          this.ipagination.total = 0
          this.$message.error(res.message || this.$t('获取数据失败'))
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(this.$t('网络请求失败'))
        console.error(err)
      })
    },
    // 接收父组件传递的区域代码变化
    handleAreaChange(areaCode) {
      this.$set(this.queryParam, 'areaCode', areaCode || '')
      this.ipagination.current = 1 // 重置到第一页
      this.loadData()
    },
  },
}
</script>
  <style scoped>
@import '~@assets/less/common.less';
</style>